import Vue from 'vue'
import './pollyfills'

import Vuex from 'vuex'
import axios from 'axios'

import VueRouter from 'vue-router'
// import VueNotify from 'vue-notifyjs'


import VueApollo from 'vue-apollo'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import App from './App.vue'


import { DataTables, DataTablesServer } from 'vue-data-tables'
import store from './store'
// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'
// Tuto menu


import './filters'
// router setup
import routes from './routes/routes'
// Dev Tools
import VueJsonContent from 'vue-json-content'

// library imports
import lodash from 'lodash'

import './assets/sass/paper-dashboard.scss'
import './assets/sass/element_variables.scss'
import './assets/sass/demo.scss'


import sidebarLinks from './sidebarLinks'

import VueTheMask from 'vue-the-mask'

import gqlclient from './store/gqlclient'


Object.defineProperty(Vue.prototype, '$lodash', { value: lodash })

Vue.use(VueJsonContent)
Vue.use(VueTheMask)
Vue.use(Vuex)
// plugin setup
Vue.use(VueRouter)
Vue.use(ElementUI, { locale })
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
// Vue.use(VueNotify, {timeout: 5000})
Vue.use(SideBar, {sidebarLinks: sidebarLinks})
// Vue.use(VeeValidate)
Vue.use(DataTables)
Vue.use(DataTablesServer)

// locale.use(lang)
Vue.use(require('vue-moment'))

Vue.use(VueApollo)


// configure router
export const router = new VueRouter({
  routes, // short for routes: routes
  // mode: 'history',
  linkActiveClass: 'active'
})


const apolloProvider = new VueApollo({
  defaultClient: gqlclient,
  
  errorHandler (error) {
    console.log('Global error handler', error.networkError.statusCode);
    
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  apolloProvider,
  axios,
  router,

  render: h => h(App)

})

const token = localStorage.getItem('user-token')
if (token) {
  axios.defaults.headers.common['Authorization'] = token
}



// WEBPACK FOOTER //
// ./src/main.js